import { render } from "./KarussellFeiern2.vue?vue&type=template&id=124fcfa8"
import script from "./KarussellFeiern2.vue?vue&type=script&lang=js"
export * from "./KarussellFeiern2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__